/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {Column} from 'react-table'
import Swal from 'sweetalert2'
import {KTCard, KTSVG} from '../../../../../../../../../../_metronic/helpers'
import {
  KTable,
  KTableHeader,
  KTableLoading,
  KTableSelectionCellNonMultiple,
} from '../../../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../../../contexts/KTableProvider'
import {useLavanderia} from '../../../../../../../../hooks/useLavanderia'
import {EquipmentSupplierModel} from '../../../../../../model'
import {deleteEquipSupplier, getEquipSupplier} from '../../../../../../services'
import {ModalEquipmentSupplier} from '../modal/ModalAddEquipmentSupplier'
import {ShowSnackBar} from '../../../../../../../../util/functions'
const TableEquipmentSuppliers: FC = () => {
  const {data, setData, setPagination, loading, setLoading, clearSelected, selectedOn, pagination} =
    useKTable()
  const {currentTabItem, isAllowed} = useLavanderia()
  const [showModalNew, setShowModalNew] = useState(false)
  const [equipmentToEdit, setEquipmentToEdit] = useState<EquipmentSupplierModel | any>(null)
  const [createdModal, setCreatedModal] = useState(false)

  const getEquipmentSupplierFn = async () => {
    try {
      clearSelected()
      setLoading(true)
      const {data: response} = await getEquipSupplier(
        {
          proveedorId: currentTabItem.idToEdit,
        },
        pagination.currentPage,
      )
      if (!response.error) {
        setData(response.data)
        setPagination({
          ...pagination,
          totalResults: response.total,
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const handleEdit = (item: EquipmentSupplierModel) => {
    setCreatedModal(false)
    setEquipmentToEdit(item)
    setShowModalNew(true)
  }
  useEffect(() => {
    getEquipmentSupplierFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  useEffect(() => {
    getEquipmentSupplierFn()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  const columns: Column<EquipmentSupplierModel>[] = [
    {
      Header: (props) => <KTableHeader tableProps={props} />,
      id: 'selection',
      Cell: ({...props}) => <KTableSelectionCellNonMultiple id={props.data[props.row.index].id} />,
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tipo de Equipo' />,
      accessor: 'tipoEquipoNombre',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Nomenclatura de Equipo' />,
      accessor: 'nomenclatura',
    },
    {
      Header: (props) => (
        <KTableHeader tableProps={props} title='Capacidad de Lavado Ropa Usuario' />
      ),
      accessor: 'capacidadLavadoUsuario',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Capacidad de Lavado Ropa Cama' />,
      accessor: 'capacidadLavadoCama',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Tiempo de Entrega' />,
      accessor: 'tiempo',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Estado' />,
      accessor: 'estado',
    },
    {
      Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
      id: 'actions',
      Cell: ({...props}) => (
        <>
          {isAllowed('EQUIPOPROVEEDORES/EDITAR') && (
            <div
              className='d-flex justify-content-center flex-shrink-0'
              onClick={() => handleEdit(props.row.original)}
            >
              <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                <KTSVG path='/media/icons/duotune/general/gen055.svg' className='svg-icon-3' />
              </a>
            </div>
          )}
        </>
      ),
    },
  ]

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  const handleDelete = async () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Al eliminar no podrás revertir esta acción',
      //showDenyButton: true,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, eliminar',
      confirmButtonColor: 'var(--kt-primary)',
      //denyButtonText: `Don't save`,
      cancelButtonText: 'No',
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
    }).then(async (result) => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed) {
        const itemToDelete = selectedOn[0] || null
        // setLoading(true)
        const {data: response} = await deleteEquipSupplier(itemToDelete)
        if (!response.error) {
          ShowSnackBar('Se eliminó satisfactoriamente')
          getEquipmentSupplierFn()
        } else {
          ShowSnackBar(response.message, 'error')
        }
        Swal.close()
      } else if (result.isDenied) {
        //Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  const handleNew = () => {
    setCreatedModal(true)
    setShowModalNew(true)
  }

  return (
    <>
      <KTCard shadow className='m-5'>
        <div className='d-flex justify-content-end p-2 me-5'>
          {isAllowed('EQUIPOPROVEEDORES/AGREGAR') && (
            <button type='button' className='btn btn-success me-3' onClick={handleNew}>
              Agregar
            </button>
          )}
          {isAllowed('EQUIPOPROVEEDORES/ELIMINAR') && (
            <button
              type='button'
              className='btn btn-primary me-3'
              disabled={selectedOn.length < 1}
              onClick={handleDelete}
            >
              Eliminar
            </button>
          )}
        </div>
        {isAllowed('EQUIPOPROVEEDORES/LISTAR') && (
          <>
            <KTable data={data} columns={columns} classNameProps='dataTablecentral' />
            {loading ? <KTableLoading title='Cargando...' /> : null}
          </>
        )}

        {showModalNew ? (
          <ModalEquipmentSupplier
            show={showModalNew}
            equipmentToEdit={equipmentToEdit}
            setShow={setShowModalNew}
            getLegalRepresentatives={getEquipmentSupplierFn}
            created={createdModal}
          />
        ) : (
          <></>
        )}
      </KTCard>
    </>
  )
}

const TableEquipmentSuppliersWrapper = () => {
  return (
    <KTableProvider>
      <TableEquipmentSuppliers />
    </KTableProvider>
  )
}
export {TableEquipmentSuppliersWrapper}
